import { useUser } from 'hooks'

export function useIsSubscribed() {
  return useUser()?.organization?.pricingPlan === 'paid'
}
